import React from 'react'
import { compose, withStateHandlers } from 'recompose';
import { SelectLanguage } from '../theme/globalStyle'

const LanguageSwitcher = ({ selectLanguage, lang }) => (
	<SelectLanguage id="langpage" name="langpage" value={lang} onChange={e => selectLanguage(e.target.value)}>
		<option value="es" key="Español">Español</option>
		<option value="pt" key="Português">Português</option>
		<option value="en" key="English">English</option>
	</SelectLanguage>
)

const enhance = compose(
	withStateHandlers(
		props => ({ language: props.lang }),
		{
			selectLanguage: (values, { toggleLanguage }) => value => {
				toggleLanguage(value)
				return {
					language: value
				}
			}
		}
	)
)

export default enhance(LanguageSwitcher)